export default __webpack_public_path__ + "static/media/mid-b-13-thumb.73af8cfe.jpg";